import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ClearDelete = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.BgColor ? "0 0 105 104" : "0 0 20 20"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}
            visibility={props.visibility}
            onClick={props.onClick}>
            {props.BgColor ? <rect x="0.5" width="104" height="104" rx="50" fill={props.BgColor} /> : null}
            <path d="M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
           fill={props.color ? props.color: "white"} />
            <path d="M13 7L7 13M7 7L13 13" stroke="white" strokeWidth="1.25" strokeLinecap="round" />
        </SvgStyled>
    );
};

export default ClearDelete;
